import styled from 'styled-components'
import colors from '../../../theming/variables/colors'

interface ComponentProps {
  readonly active: boolean
}

export const Icon = styled.div`
  align-items: center;
  background-color: transparent;
  display: flex;
  flex-basis: 4.8rem;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 1.4rem;
  justify-content: center;
  margin-right: ${(props) => (props.theme.collapsed ? '0' : '0.5rem')};
  min-height: 4.8rem;
`

export const Link = styled.a`
  align-items: center;
  border: 0;
  color: inherit;
  display: flex;
  margin-bottom: 0.5rem;
  padding: 0;
  position: relative;
  text-decoration: none;
`

export const Text = styled.div`
  display: ${(props) => (props.theme.collapsed ? 'none' : 'inline-block')};
`

export const Item = styled.div<ComponentProps>`
  color: ${(props) => (props.active ? colors.orange1 : colors.black1)};
  transition: color 0.25s;
  border-left: 0.2rem solid ${(props) => (props.active ? colors.orange1 : colors.white1)};

  &:hover {
    color: ${colors.orange1};
    transition: color 0.25s;
  }

  ${Icon} {
    color: ${(props) => (props.active ? colors.orange1 : 'inherit')};
  }
`
